<template>
  <Popup style="background-color: rgba(0, 0, 0, 0);" v-model:show="show" position="bottom">
    <div class="select">
      <div class="select__bar">
        <div class="select__cancel" @click="close">取消</div>
        <div class="select__title">选择取车时间</div>
        <div class="select__submit" @click="confirm">确定</div>
      </div>
      <div class="select__picker">
        <DatetimePicker v-model="selectDate" :show-toolbar="false" :min-date="minDate" :formatter="formatter" type="date"
          :filter="filter" @change="changeHandler" />
      </div>

    </div>
  </Popup>
</template>
<script setup>
import { Popup, DatetimePicker } from 'vant';
import { ref, onMounted } from "vue";
import moment from "moment";
const emit = defineEmits(['ok'])

const show = ref(false)
const tomorrow = new moment().add(1, 'd').toDate()
const minDate = ref(tomorrow)
const open = (date) => {
  selectDate.value = date ? date : tomorrow
  show.value = true
}
const close = () => {
  show.value = false
}
const confirm = () => {
  const m = new moment(selectDate.value)
  m.hours(0)
  m.minutes(0)
  m.seconds(0)
  emit('ok', m)
  close()
}
// 格式化
const formatter = (type, value) => {
  switch (type) {
    case 'year':
      return `${value}年`
    case 'month':
      return `${value}月`
    case 'day':
      return `${value}日`
    case 'hour':
      return `${value}时`
    // case 'minute':
    //   return `${value}分`
    default:
      return value
  }
}
// 过滤选项
const filter = (type, value) => {
  return value
}
const selectDate = ref(null)
const changeHandler = (e) => {
  selectDate.value = e
}
defineExpose({
  open,
  close,
})
</script>
<style lang="scss" scoped>
.select {
  background-color: #fff;
  width: 100%;
  padding-bottom: env(safe-area-inset-bottom);
}

// 隐藏分的选项
::v-deep .van-picker-column:nth-child(5) {
  display: none;
}

.select__bar {
  position: relative;
  display: flex;
  align-items: center;
  font-size: 34px;
  color: #232323;
  padding: 40px 40px 16px;
  justify-content: space-between;

  &::after {
    content: '';
    height: 1px;
    background: #dedede;
    position: absolute;
    bottom: 0;
    left: 40px;
    right: 40px;
    transform: scale(1, 0.5);
  }
}

.select__title {
  color: #8E9496;
  font-size: 30px;
  text-align: center;
}

::v-deep .van-hairline-unset--top-bottom.van-picker__frame {
  display: none;
}

::v-deep .van-picker__mask {
  background-image: linear-gradient(180deg, rgba(255, 255, 255, .8), rgba(255, 255, 255, .8)), linear-gradient(0deg, rgba(255, 255, 255, .8), rgba(255, 255, 255, .8));
}

::v-deep .van-picker-column__item {
  font-size: 38px;
  font-weight: 500;
}
</style>